import initialState from './initialState'

const FETCH_IMAGES = 'md/features/press/HeaderImage/FETCH_IMAGES'
const FETCH_IMAGES_SUCCESS = 'md/features/press/HeaderImage/FETCH_IMAGES_SUCCESS'
const FETCH_IMAGES_FAILED = 'md/features/press/HeaderImage/FETCH_IMAGES_FAILED'

export const fetchImages = () => {
  return {
    types: [FETCH_IMAGES, FETCH_IMAGES_SUCCESS, FETCH_IMAGES_FAILED],
    callApi: {
      endpoint: 'api/webimages/3',
      method: 'GET'
    }
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_IMAGES:
      return {
        ...state,
        loading: true
      }
    case FETCH_IMAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        images: action.data
      }
    case FETCH_IMAGES_FAILED:
      return {
        ...state,
        loading: false
      }
    default:
      return state
  }
}